import http from 'axios'

export const getAvailable1800Numbers = () => ({
  type: 'NUMBERS_1800/GET_AVAILABLE_NUMBERS',
  payload: http({
    method: 'GET',
    url: 'api/v1/numbers/1800/available',
  }),
})



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers1800/Numbers1800.actions.js